import { Result, Button, Spin } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { checkSubmissionStatus } from "../../services/serviceCollections/dmqService";

const Maintenance = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [loading, setLoading] = useState(false);

  const checkAndRedirect = async () => {
    try {
      setLoading(true);

      const memberId = location.state?.memberId;
      const result = await checkSubmissionStatus(memberId);

      if (!result?.data?.maintenanceMode) {
        navigate(`${location.state?.from || "/login"}${location.state?.search || ""}`, { replace: true });
      }
    } catch (err) {
      // still under maintenance → do nothing
      console.log("Still under maintenance");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkAndRedirect();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      checkAndRedirect();
    }, 600000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Result
        status="warning"
        title="We'll Be Back Soon!"
        subTitle="Our system is under maintenance."
        extra={[
          <Button type="primary" onClick={checkAndRedirect} loading={loading} disabled={loading}>
            {loading ? "Checking..." : "Retry"}
          </Button>,
        ]}
      />
    </div>
  );
};

export default Maintenance;
